export default __webpack_public_path__ + "img/tremors/tremors7_1500.webp";